/* eslint-disable global-require */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useCallback, useMemo, useState } from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import {useLocation} from 'react-router-dom';
import UserHasAccess from 'hooks/UserHasAccess';
import {useDispatch, useSelector} from 'react-redux';
import useStyles from './styles';
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import * as actions from "../../store/actions";
import useLocalStorage from "../../hooks/useLocalStorage";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Logout, Sync } from '@mui/icons-material';
import SideBar from "./Sidebar";
import { closeModal, openModal } from '../Modal/modalReducer';
import { syncOrganizationCashFlow } from '../../store/actions';

const isDevProject = window.location.hostname.includes('dev');

const navLinks = [
    {path: '/', name: 'Home'},
    {path: '/Portfolios', name: 'Portfolios'},
    {path: '/Assets', name: 'Assets'},
    {path: '/Tenants', name: 'Leases'},
    {path: '/Dashboard', name: 'Dashboard'},
    {path: '/Invoice', name: 'Invoice manager', devOnly: true}
].filter((link) => !link.devOnly || isDevProject);

function ToolbarComponent() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {open} = useSelector((state) => state.alerts);
    const userNotifications = useSelector((state) => state.alerts.alerts.length);
    const role = useSelector((state) => state.user.userPermissions.roletitle);
    const userPermissions = useSelector((state) => state.user.userPermissions.permissionsList);
    const assetAccess = UserHasAccess('asset', 'view', userPermissions);
    const [hover, setHover] = useState(false);
    const location = useLocation();
    const {removeValue} = useLocalStorage('token', null);
    const userRoles = useSelector((state) => state.user.userRoles);
    const isPortfolioManager = useMemo(
      () => userRoles.some((it) => it.roletitle === 'Portfolio manager'),
      [userRoles]
    );

    const handleSignOut = useCallback(() => {
        removeValue();
        dispatch(actions.signOut());
    }, []);

    const handleCashFlowSync = () => {
      dispatch(
        openModal({
          modalType: 'AlertModal',
          modalProps: {
            title: 'Sync organization cash flow',
            content: `Are you sure you want to re-sync the organization cash flow to latest lease contracts state?`,
            handleConfirm: () =>
              dispatch(syncOrganizationCashFlow()).then(() =>
                dispatch(
                  openModal({
                    modalType: 'AlertModal',
                    modalProps: {
                      title: 'Organization cash flow sync has started',
                      confirmButtonText: 'OK',
                      cancelButtonText: 'Close',
                      content: `NOTE: the cash flow sync operation can take some time to complete!`,
                      handleConfirm: () => dispatch(closeModal())
                    }
                  })
                )
              )
          }
        })
      );
    };

    return (
        <AppBar position="static" style={
            {
                backgroundColor: '#1B2740',
                position: 'fixed',
                zIndex: 1000,
                paddingLeft: 0
            }
        }>
            {assetAccess && <SideBar open={open} setOpen={() => dispatch(actions.toggleAlertMenu())}/>}
            <Toolbar disableGutters>
                <Box sx={{flexGrow: 1, display: {xs: 'none', sm: 'block'}}}>
                    {navLinks.map((item) => (
                        <Button key={item.name} sx={{
                            paddingRight: '40px',
                            textTransform: 'none',
                            fontSize: '18px',
                            fontWeight: 500,
                            color: location.pathname === item.path ? '#FFF' : '#9BA9C4',
                            margin: 1,
                            '&:hover': {
                                color: '#FFF',
                                backgroundColor: 'transparent'
                            }
                        }} to={item.path} disableRipple>
                            {item.name}
                        </Button>
                    ))}
                </Box>
                <Box sx={{flexGrow: 0, margin: 1}}>
                    {window.location.hostname.includes('pre-prod') && <Button sx={{
                        paddingRight: '40px',
                        textTransform: 'none',
                        fontSize: '18px',
                        fontWeight: 500,
                        color: location.pathname === "/ADA" ? '#FFF' : '#9BA9C4',
                        margin: 1,
                        '&:hover': {
                            color: '#FFF',
                            backgroundColor: 'transparent'
                        }
                    }} to="/ADA" disableRipple>
                        Ask Ada
                    </Button>}
                  {isPortfolioManager && (
                    <IconButton onClick={handleCashFlowSync} aria-label="Sync cash flow" style={{color: '#fff'}}>
                      <Sync/>
                    </IconButton>
                  )}
                    {role && (
                        <IconButton
                            aria-label="show 14 new notifications"
                            color="inherit"
                            onClick={() => dispatch(actions.toggleAlertMenu())}
                            classes={{root: classes.iconBtn}}
                            onMouseEnter={() => setHover(true)}
                            onMouseLeave={() => setHover(false)}
                            disabled={!userNotifications}
                            size="large"

                        >
                            <Badge badgeContent={userNotifications} classes={{badge: classes.customBadge}}>
                                {userNotifications > 0 && hover ? (
                                    <NotificationsIcon/>
                                ) : (
                                    <NotificationsNoneIcon
                                        style={{
                                            color: userNotifications > 0 ? '#FFF' : '#999'
                                        }}
                                    />
                                )}
                            </Badge>
                        </IconButton>
                    )}
                    <IconButton onClick={handleSignOut} aria-label="logout" style={{color: '#fff'}}>
                        <Logout/>
                    </IconButton>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default React.memo(ToolbarComponent);
